export type CreatorProps = {
  // url: string;
  name: string;
};

/**
 * 分析の作成者（投稿ユーザー）
 */
export default function Creator({ name }: CreatorProps) {
  return (
    <div className="mt-3 flex items-center">
      {/* <UserIcon
        iconUrl={url}
        alt="投稿者アイコン"
        classNameSize="size-6"
      /> */}
      <p className="text-sm text-GRAY_1">{name}</p>
    </div>
  );
}
